import 'twin.macro';
import React from 'react';
import { ReactComponent as Icon } from './duplicate.svg';
import { IconProps } from '@teetsh/app/src/components/Icons/icon';

export function DuplicateIcon(props: IconProps) {
  return <Icon className={props.className} />;
}
